import { apiRequest } from '@/network/apiClient';
import { useState, useEffect } from 'react';
import { API_ENDPOINTS } from '@/api/apiEndpoints';
import { toast } from 'react-toastify';
// import { useUserContext } from "../../context/UserContext.jsx";


const RejectLeadButton = ({ leadID, onRefetch }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [formData, setFormData] = useState({
    rejectionReason: '',
    rejectionNotes: ''
  });

const role = localStorage.getItem('role');

const hodHunterReasons = role === 'HOD_Hunter' || role === 'Admin'
  ? ['Wrong lead source', 'Wrong MM Account ID']
  : [];

  const rejectionReasons = [
    ...hodHunterReasons,
    'Duplicate',
    'Company no longer exist',
    'Prefer bank',
    'Trust issue',
    'Use bank facilities',
    'Transfer speed',
    'Prefer convenience of agent',
    'Limitation set by recipient',
    'Recipient cannot provide supporting document',
    'Rarely does TT',
    'Unresponsive',
    'Getting better rate elsewhere (Specify)'
  ];


  const handleRejections = (e) => {
    const value = e.target.value;
    setFormData(prevState => ({
      ...prevState,
      rejectionReason: value,
    }))
  }
  const handleRejectionNotes = (e) => {
    const {name, value} = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleSubmit = async () => {
    setIsProcessing(true);
    try {
      const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.UPDATE_LEADS.REJECT_LEAD}?id=${leadID}`,'POST', formData)

      // refetch details
      onRefetch()
      toast.success('Lead Successfully Rejected')

    } catch (error) {
      toast.error(error || 'Error rejecting lead')
    } finally {
      setIsProcessing(false);
      setIsModalOpen(false);
    }
  };

  return (
    <>
      {/* Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className={`py-2 md:py-3 px-4 md:px-5 rounded-full transition text-sm md:text-lg font-bold min-h-[44px] ${
          isRejected
            ? 'bg-red-100 text-red-500 hover:bg-red-200'
            : 'bg-white text-black border-[1px] border-black  hover:bg-gray-50'
        }`}
        disabled={isProcessing}
      >
        {isProcessing ? 'Processing...' : 'Reject Lead'}
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50 p-4">
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg w-full max-w-md md:w-1/3">
            {/* Modal Header */}
            <div className="ml-2">
              <p className="text-xl md:text-2xl font-semibold text-gray-900">Reject Lead?</p>
            </div>

            {/* Modal Body */}
            <div className="ml-2 mt-4">
              <p className="text-sm md:text-md">Do you want to proceed with rejecting this lead?<br></br>Once rejected, this action cannot be undone.</p>
              <label htmlFor="rejectionReason" className="block text-sm font-medium text-gray-700 mb-1 mt-4">
                Reason for rejection
              </label>
              <select
                name="rejectionReason"
                value={formData.rejectionReason}
                onChange={handleRejections}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                required
              >
                <option value="">Select a reason</option>
                {rejectionReasons.map((reason) => (
                  <option key={reason} value={reason}>
                    {reason}
                  </option>
                ))}
              </select>
            </div>

            {/* Show text field when "Others" is selected or always show it for comments */}
        {(formData.rejectionReason === 'Getting better rate elsewhere (Specify)') && (
          <div className="mt-4 ml-2">
            <label htmlFor="rejectionNotes" className="block text-sm font-medium text-gray-700 mb-1">
              Additional notes
            </label>
            <textarea
              name="rejectionNotes"
              value={formData.rejectionNotes}
              onChange={handleRejectionNotes}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
              rows={3}
              placeholder="Please specify the reason for rejection..."
            />
          </div>
        )}

            {/* Modal Footer */}
            <div className="px-2 md:px-6 py-4 flex flex-col sm:flex-row justify-end gap-2 sm:gap-0 sm:space-x-3 mt-3 -mb-4 md:-mb-6">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 md:px-6 py-2.5 md:py-3 font-bold bg-white rounded-full hover:bg-gray-400 text-black border-[1px] border-black text-sm md:text-base min-h-[44px]"
                disabled={isProcessing}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={!formData.rejectionReason || isProcessing}
                className="px-4 md:px-8 py-2.5 md:py-3 font-bold bg-yellow-500 text-black rounded-full hover:bg-yellow-600 transition-colors duration-200 disabled:bg-yellow-300 disabled:cursor-not-allowed text-sm md:text-base min-h-[44px]"
              >
                {isProcessing ? 'Processing...' : 'Reject Lead'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RejectLeadButton;

// Example usage:
// <RejectLeadButton onReject={(reason) => console.log('Lead rejected because:', reason)} />